<template>
  <div>
    <v-card elevation="0" class="mb-3 rounded-lg">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="12">
            <h5 class="text_color--text">
              {{ operationalAnalyticsModule.operationalAnalyticPlural }}
            </h5>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="d-flex py-0 app-custom-search-input">
        <InputField
          id="search"
          name="search"
          class="mr-1"
          label="search here.."
          prepend-inner-icon="mdi-magnify"
          outlined
          background-color="background_color"
          v-model="search"
          dense
          hide-details="auto"
        >
        </InputField>
      </v-card-text>
      <v-card-text style="height: 50px">
        <v-tabs
          v-if="isCurrentTabsVisible"
          :show-arrows="true"
          fixed-tabs
          background-color="white"
          active-class="primary-text"
          v-model="currentTripTab"
        >
          <v-tab small class="background-white">
            <h5>
              <span>ongoing</span>
              <span v-if="search && currentTripTab == 0">
                ({{ ongoingTripsCount }})
              </span>
              <span v-else> ({{ tripCount.ongoing_trips }}) </span>
            </h5>
          </v-tab>
          <v-tab class="background-white">
            <h5>
              <span>completed</span>
              <span v-if="search && currentTripTab == 1">
                ({{ completedTripsCount }})
              </span>
              <span v-else> ({{ tripCount.completed_trips }}) </span>
            </h5>
          </v-tab>
        </v-tabs>

        <v-tabs
          v-else
          :show-arrows="true"
          fixed-tabs
          background-color="white"
          active-class="primary-text"
          v-model="previousTripTab"
        >
          <v-tab small>
            <h5>
              <span>{{ tripModule.tripPlural }}</span>
              <span v-if="search && previousTripTab == 0">
                ({{ previousCompletedTripsCount }})
              </span>
              <span v-else> ({{ tripCount.completed_trips }})</span>
            </h5>
          </v-tab>
          <v-tab class="background-white">
            <h5>
              <span>{{ fleetModule.driverPlural }}</span>
              <span v-if="search && previousTripTab == 1">
                ({{ driverListCount }})
              </span>
              <span v-else> ({{ tripCount.drivers }})</span>
            </h5>
          </v-tab>
        </v-tabs>
      </v-card-text>
    </v-card>
    <v-card
      elevation="0"
      class="overflow-y-auto app-list rounded-lg"
      id="order-target"
    >
      <v-tabs-items
        v-if="isCurrentTabsVisible"
        v-model="currentTripTab"
        class="background_color"
        style="height: calc(100vh - 250px)"
      >
        <v-tab-item
          ref="operationParent"
          @scroll="scrollControlTrip('ongoing')"
          class="overflow-y-auto"
          style="height: calc(100vh - 250px)"
        >
          <v-card
            elevation="0"
            v-if="ongoingTrips.length == 0"
            class="d-flex justify-center align-center h-100"
          >
            <v-card-text>
              <h5 class="text-caption text-center">
                No Ongoing {{ tripModule.tripPlural }} at the moment.
              </h5>
            </v-card-text>
          </v-card>
          <div v-else>
            <v-expansion-panels
              v-model="tripExpansion"
              flat
              multiple
              class="app-list-card-expansion"
            >
              <v-expansion-panel
                elevation="0"
                v-for="(trip, i) in ongoingTrips"
                :key="i"
                class="px-3 py-1 ma-0 mb-2 rounded-lg"
                :class="
                  selectedId && trip && selectedId == trip.id
                    ? 'sub_heading darken-1'
                    : ''
                "
              >
                <TripListCard :trip="trip" @onSelectedTrip="selectedTrip" />
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-tab-item>
        <v-tab-item
          ref="operationCompletedParent"
          @scroll="scrollControlTrip('completed')"
          class="overflow-y-auto"
          style="height: calc(100vh - 250px)"
        >
          <v-card
            elevation="0"
            v-if="completedTrips.length == 0"
            class="d-flex justify-center align-center h-100"
          >
            <v-card-text>
              <h6 class="text-caption text-center">
                No Completed {{ tripModule.tripPlural }} at the moment.
              </h6>
            </v-card-text>
          </v-card>

          <div v-show="completedTrips.length > 0">
            <v-expansion-panels
              v-model="tripExpansion"
              flat
              class="background_color app-list-card-expansion"
            >
              <v-expansion-panel
                elevation="0"
                v-for="(trip, i) in completedTrips"
                :key="i"
                class="px-3 py-1 ma-0 mb-2 card-box-shadow"
              >
                <TripListCard :trip="trip" />
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-tab-item>
      </v-tabs-items>
      <v-tabs-items
        class="background_color"
        style="height: calc(100vh - 250px)"
        v-else
        v-model="previousTripTab"
      >
        <v-tab-item
          ref="tripParent"
          @scroll="scrollControlTrip('trip')"
          class="overflow-y-auto"
          style="height: calc(100vh - 250px)"
        >
          <v-card
            elevation="0"
            v-if="previousCompletedTrips.length == 0"
            class="d-flex justify-center align-center h-100"
          >
            <v-card-text>
              <h6 class="text-caption text-center">
                No {{ tripModule.tripPlural }} at the moment.
              </h6>
            </v-card-text>
          </v-card>

          <div v-show="previousCompletedTrips.length > 0">
            <v-expansion-panels
              v-model="tripExpansion"
              flat
              class="app-list-card-expansion"
            >
              <v-expansion-panel
                elevation="0"
                v-for="(trip, i) in previousCompletedTrips"
                :key="i"
                class="px-3 py-1 ma-0 mb-2 card-box-shadow"
              >
                <TripListCard :trip="trip" />
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-tab-item>
        <v-tab-item
          ref="driverParent"
          @scroll="scrollControlTrip('driver')"
          class="overflow-y-auto"
          style="height: calc(100vh - 250px)"
        >
          <v-card
            elevation="0"
            v-if="driverList.length == 0"
            class="d-flex justify-center align-center h-100"
          >
            <v-card-text>
              <h6 class="text-caption text-center">
                No {{ fleetModule.driverPlural }} at the moment.
              </h6>
            </v-card-text>
          </v-card>

          <div v-show="driverList.length > 0">
            <v-expansion-panels
              v-model="driverExpansion"
              flat
              class="app-list-card-expansion"
            >
              <v-expansion-panel
                elevation="0"
                v-for="(driver, i) in driverList"
                :key="i"
                class="px-3 py-1 ma-0 mb-2 card-box-shadow"
              >
                <DriverListCard :driver="driver" />
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>


<script>
import { bus } from "@/main.js";
import {
  operationalAnalyticsModule,
  tripModule,
  fleetModule,
} from "@/utils/moduleMapping";
import DriverListCard from "@/components/ModuleBasedComponents/Operation/DriverListCard.vue";
import TripListCard from "@/components/ModuleBasedComponents/Trip/TripListCard.vue";
import { returnToday } from "@/utils/functions";

export default {
  components: {
    DriverListCard,
    TripListCard,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    selectedTripId: {
      default: null,
    },
  },
  data() {
    return {
      operationalAnalyticsModule,
      tripModule,
      fleetModule,
      currentTripTab: 0,
      previousTripTab: 0,
      tripCount: {},
      search: null,
      ongoingTrips: [],
      completedTrips: [],
      previousCompletedTrips: [],
      driverList: [],
      date: returnToday(),
      tripExpansion: [0],
      searchDrivers: null,
      driverExpansion: null,
      selectedId: null,
      completedTripsCount: null,
      ongoingTripsCount: null,
      previousCompletedTripsCount: null,
      driverListCount: null,
      tripsTab: 0,
    };
  },
  computed: {
    isCurrentTabsVisible() {
      return this.filters?.date && this.date && this.filters.date != this.date
        ? false
        : true;
    },
    mainTabHeight() {
      return `${window.innerHeight - 270}px`;
    },
    tabHeight() {
      return `${window.innerHeight - 270}px`;
    },
    tripOffset() {
      return this.tripsTab == 0
        ? this.ongoingTrips?.length
        : this.completedTrips?.length;
    },
  },
  watch: {
    selectedTripId(val) {
      if (!val) {
        this.selectedId = null;
      }
    },
    search() {
      if (this.isCurrentTabsVisible) {
        if (this.tripsTab == 0) {
          this.getTripCounts();
          this.getTripList(true, "ongoing");
        } else {
          this.getTripCounts();
          this.getTripList(true, "completed");
        }
      } else {
        if (this.previousTripTab == 0) {
          this.getTripCounts();
          this.getCompletedTripList({}, true);
        } else {
          this.getTripCounts();
          this.getDriverList({}, true);
        }
      }
    },
    filters: {
      handler() {
        this.getTripCounts();
        this.getCompletedTripList({}, true);
        if (this.previousTripTab == 1){
          this.getDriverList({}, true);
        }
      },
      deep: true,
    },
    currentTripTab(val) {
      if (val) {
        this.getTripCounts();
        this.getTripList(true, "ongoing");
      } else {
        this.getTripCounts();
        this.getTripList(true, "completed");
      }
    },
    previousTripTab(val) {
      if (val == 0) {
        this.getTripCounts();
        this.getCompletedTripList({}, true);
      } else {
        this.getTripCounts();
        this.getDriverList({}, true);
      }
    },
    isCurrentTabsVisible(val) {
      if (val) {
        this.getTripCounts();
        this.getTripList(true);
      } else {
        this.selectedId = null;
        // this.getCompletedTripList({}, true);
      }
    },
  },
  methods: {
    selectedTrip(e) {
      if (this.selectedId == e.id) {
        this.selectedId = null;
      } else {
        this.selectedId = e.id;
      }

      this.$emit("selectedTripChanged", e);
    },
    clearDriverSearch() {
      this.searchDrivers = null;
      this.getTripCounts();
      this.getDriverList({}, true);
    },
    scrollControlTrip(type = "ongoing") {
      let elem = null;
      if (type == "ongoing") {
        elem = this.$refs.operationParent;
      } else if (type == "completed") {
        elem = this.$refs.operationCompletedParent;
      } else if (type == "trip") {
        elem = this.$refs.tripParent;
      } else if (type == "driver") {
        elem = this.$refs.driverParent;
      }

      if (elem == null) {
        return false;
      } else if (
        Math.ceil(elem.$el.offsetHeight + elem.$el.scrollTop) ==
        elem.$el.scrollHeight
      ) {
        if (
          type == "ongoing" &&
          this.ongoingTrips.length != this.ongoingTripsCount
        ) {
          this.getTripList(false, "ongoing");
        } else if (
          type == "completed" &&
          this.completedTrips.length != this.completedTripsCount
        ) {
          this.getTripList(false, "completed");
        } else if (type == "trip") {
          this.getCompletedTripList({});
        } else if (type == "driver") {
          this.getDriverList({});
        }
      }
    },

    getDriverList(params = {}, reload = false) {
      params = {
        ...params,
        search: this.search,
        ...this.filters,
        offset: reload ? 0 : this.driverList?.length,
        limit: 20,
      };
      if (this.searchDrivers) {
        params.search = this.searchDrivers;
      }
      if (this.selectedProjects && this.selectedProjects.length > 0) {
        params.project = this.selectedProjects.join(",");
      }

      if (reload) {
        this.isDriverListScrollable = true;
      }
      if (this.isDriverListScrollable) {
        bus.$emit("showLoader", true);
        this.$api.newOperation
          .getDriverList(params)
          .then((res) => {
            bus.$emit("showLoader", false);
            this.driverListCount = res.count;
            if (reload) {
              this.driverList = res.data;
            } else {
              this.driverList = [...this.driverList, ...res.data];
            }
            if (this.driverList.length == this.driverListCount) {
              this.isDriverListScrollable = false;
            }
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            console.error(err);
            this.driverList = [];
          });
      }
    },
    getCompletedTripList(params = {}, reload = false) {
      params = {
        ...params,
        ...this.filters,
        completed_trips: true,
        search: this.search,
        offset: reload ? 0 : this.previousCompletedTrips?.length,
        limit: 20,
      };

      if (reload) {
        this.isPreviousCompletedTripsScrollable = true;
      }
      if (this.isPreviousCompletedTripsScrollable) {
        bus.$emit("showLoader", true);
        this.$api.operation
          .getOperationTripList(params)
          .then((res) => {
            bus.$emit("showLoader", false);
            this.previousCompletedTripsCount = res.count;

            if (reload) {
              this.previousCompletedTrips = res.data;
            } else {
              this.previousCompletedTrips = [
                ...this.previousCompletedTrips,
                ...res.data,
              ];
            }
            if (
              this.previousCompletedTrips.length ==
              this.previousCompletedTripsCount
            ) {
              this.isPreviousCompletedTripsScrollable = false;
            }
          })
          .catch((err) => {
            bus.$emit("showLoader", false);
            console.error(err);
            this.previousCompletedTrips = [];
          });
      }
    },
    getTripCounts(params = {}) {
      params = {
        ...params,
        trip_date: this.filters.date,
      };
      bus.$emit("showLoader", true);
      this.$api.newOperation
        .getTripDriverCounts(params)
        .then((res) => {
          bus.$emit("showLoader", false);

          this.tripCount = res.data;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripList(reload = false, tripType = "ongoing", params = {}) {
      params = {
        ...params,
        date: this.date,
        ...this.filters,
        offset: reload ? 0 : this.tripOffset,
        completed_trips: this.currentTripTab == 0 ? false : true,
        search: this.search,
        limit: 20,
      };

      bus.$emit("showLoader", true);
      this.$api.operation
        .getOperationTripList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          if (this.currentTripTab == 0) {
            this.ongoingTripsCount = res.count;
            this.ongoingTrips = reload
              ? res.data
              : [...this.ongoingTrips, ...res.data];
          } else {
            this.completedTripsCount = res.count;
            this.completedTrips = reload
              ? res.data
              : [...this.completedTrips, ...res.data];
          }
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.error(err);
          this.ongoingTrips = [];
          this.completedTrips = [];
        });
    },
  },

  mounted() {
    this.getTripList(true, "ongoing");
    this.getTripCounts();
  },
};
</script>